import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { constants } from '../../../constants';
import { UserFreemium } from '../../auth/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UpsaleModalService {
  private modalState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public modalStateObs = this.modalState.asObservable();

  public open(): void {
    const userOpenToolModel: UserFreemium = JSON.parse(
      localStorage.getItem(constants.registeredUserOpenToolStorageKey)!
    );

    if (window.location.href.includes('dashboard')) {
      window.open(
        `https://worlddata.pro/contact-us/?first_name=${userOpenToolModel.firstName}&last_name=${userOpenToolModel.lastName}&company_name=${userOpenToolModel.organizationName}&company_email=${userOpenToolModel.email}`,
        '_blank'
      );
    } else {
      window.open(
        `https://staging.worlddata.pro/contact-us/?first_name=${userOpenToolModel.firstName}&last_name=${userOpenToolModel.lastName}&company_name=${userOpenToolModel.organizationName}&company_email=${userOpenToolModel.email}`,
        '_blank'
      );
    }
    // this.modalState.next(true);
  }

  public close(): void {
    // this.modalState.next(false);
  }
}
